import Vue from 'vue'
const validation = (i, input) => {
    switch (i) {
        case 1:
            // 验证码验证
            let valid = /^\d{6}$/
            if (valid.test(input)) {
                return true
            } else {
                return false
            }

        case 2:
            let re = new RegExp("[\\u4e00-\\u9fa5]", "");
            if (re.test(input)) {
                return true
            } else {
                return false
            }

        case 3:
            let phoneCodeVerification = /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/;
            if (phoneCodeVerification.test(input)) {
                return true
            } else {
                return false
            }
        case 4:
            let digital = /^\d+$/
            let TheDecimal = /^((([^0][0-9]+|0)\.([0-9]{1,3}))$)|^(([1-9]+)\.([0-9]{1,3})$)/
            if (digital.test(input) || TheDecimal.test(input)) {
                return true
            } else {
                return false
            }
    }
}


export default function (Vue) {
    //添加全局API

    Vue.prototype.$min = {
        validation
    }

}


// WEBPACK FOOTER //
// ./src/assets/js/min.js